<template>
    <div class="user camp-member-page">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl" class="pb-5">
            <b-row>
                <b-col cols="12" md="2" class="member-sidebar-col">
                    <nacUser></nacUser>
                </b-col>

                <b-col cols="12" md="10" class="member-content-col">
                    <b-card no-body>
                        <template #header>
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="font-weight-bold">
                                    家庭成員
                                    <b-badge pill variant="primary" class="ml-1">{{ relations.length }}</b-badge>
                                </span>
                                <b-button size="sm" variant="primary" @click="goForm()">新增學員</b-button>
                            </div>
                        </template>

                        <div v-if="relationsLoading" class="text-center py-4">
                            <b-spinner></b-spinner>
                        </div>

                        <b-alert v-else-if="relations.length === 0" show variant="primary" class="m-3">
                            尚未新增學員資料
                        </b-alert>

                        <b-list-group v-else flush class="relation-list">
                            <b-list-group-item v-for="r in relations" :key="r.Id" class="relation-list-item">
                                <div class="d-flex justify-content-between align-items-start">
                                    <div>
                                        <div class="relation-name-row">
                                            <b-badge v-if="r.GenderName" variant="secondary" class="mr-2">{{ r.GenderName }}</b-badge>
                                            <strong>{{ r.Name }}</strong>
                                            <span v-if="formatEnglishName(r.EnglishLastName, r.EnglishFirstName, r.EnglishName)" class="text-muted ml-1">{{ formatEnglishName(r.EnglishLastName, r.EnglishFirstName, r.EnglishName) }}</span>
                                        </div>
                                        <div class="small text-muted mt-1">
                                            {{ r.Birthday | datefmt('YYYY/MM/DD') }}
                                            <template v-if="r.GradeName || r.School">
                                                ・{{ r.GradeName }}{{ r.GradeMemo ? '（' + r.GradeMemo + '）' : '' }}{{ r.School ? ' / ' + r.School : '' }}
                                            </template>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-shrink-0 ml-2">
                                        <b-button size="sm" variant="outline-secondary" class="mr-1" @click="goForm(r.Id)">編輯</b-button>
                                        <b-button size="sm" variant="outline-danger" @click="deleteRelation(r.Id)">刪除</b-button>
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import nacUser from '@/components/nacUser.vue';
import {
    apiGetUserRelationList,
    apiRemoveUserRelation,
} from '@/api/API.js';
import { formatEnglishName } from '@/utils/campEnums.js';

export default {
    name: 'camp-relations',
    components: {
        nacUser,
    },
    data() {
        return {
            title: '家庭成員',
            relations: [],
            relationsLoading: false,
        };
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('請先登入會員');
            this._go('/');
            return;
        }
        this.GetRelationList();
    },
    methods: {
        formatEnglishName,
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        GetRelationList() {
            this.relationsLoading = true;
            apiGetUserRelationList({ Paging: { pageSize: 9999, pageNumber: 1 } })
                .then((res) => {
                    this.relations = res.data;
                })
                .finally(() => {
                    this.relationsLoading = false;
                });
        },
        goForm(id) {
            this._go(id ? `/campRelations/${id}` : '/campRelations/new');
        },
        deleteRelation(id) {
            if (!confirm('確定要刪除此學員？')) return;
            apiRemoveUserRelation(id)
                .then(() => {
                    this.GetRelationList();
                })
                .catch(() => {
                    alert('刪除失敗，請稍後再試');
                });
        },
    },
};
</script>

<style scoped>
.relation-list-item {
    padding: 1rem 1.25rem;
}

.relation-list-item + .relation-list-item {
    border-top: 1px solid #eee;
}

.relation-name-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
</style>
